module.exports = __webpack_public_path__ + "static/images/brand_white.svg";